import ResolutionMapper from '../mappers/ResolutionMapper';

type QuestionResolutionContainerProps = {
  field?: any;
  resolutions?: any[];
};

/**
 * @typedef {object} QuestionResolutionContainerProps
 * @property {object} field - The field object.
 * @property {import('../types/question').Resolution[]} resolutions - An array of resolution objects to be rendered.
 *
 * @param {QuestionResolutionContainerProps} props
 * @returns {JSX.Element} The rendered QuestionResolutionContainer component.
 * @description QuestionResolutionContainer component that renders a list of resolutions.
 */
export default function QuestionResolutionContainer({
  field,
  resolutions,
}: Readonly<QuestionResolutionContainerProps>) {
  return (
    <div>
      {resolutions.map((resolution) => (
        <ResolutionMapper
          key={resolution.message || resolution.link?.label}
          field={field}
          resolution={resolution}
          style={{ marginTop: '0.5rem' }}
        />
      ))}
    </div>
  );
}
